module.exports = __webpack_public_path__ + "static/img/banner.3252e98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/banner.png
// module id = VwnY
// module chunks = 1